import "./header.scss";

document.addEventListener("DOMContentLoaded", function (event) {
  var menuToggle = document.getElementById("js-menu-toggle");
  var menuLabel = document.getElementById("js-menu__label");
  var header = document.getElementById("js-header");
  var nav = document.getElementById("js-nav");

  menuToggle.addEventListener("click", function () {
    menuToggle.classList.toggle("active");
    nav.classList.toggle("active");
    header.classList.toggle("active");

    if (menuToggle.classList.contains("active")) {
      menuLabel.innerHTML = "Close";
    } else {
      menuLabel.innerHTML = "Menu";
    }
  });
});
